<template>

    <div v-if="isVisible" class="modal-overlay modal">
        <div class="modal-content w-75 p-0">

            <div class="modal-header p-3">
                <div>
                    <h5 class="mb-0">Cobranças <small>({{ cobrancas.length }})</small></h5>
                    <small>{{ aplicacao?.nome }}</small>
                </div>
                <i class="ri-close-line cursor-pointer" @click="closeModal"></i>
            </div>

            <div class="modal-body p-3">

                <BaseTable :columns="dataTableHead" :rows="cobrancas" :paginationOptions="{ perPage: 50 }">

                    <template #table-row="{ column, row }">

                        <!-- Coluna de Ações -->
                        <template v-if="column.field == '__actions'">

                            <span>
                                <DropdownFloating v-model:shown="row.dropdownShown" :distance="6"
                                    placement="left-start">

                                    <div class="">
                                        <i class="ri-more-fill cursor-pointer"></i>
                                    </div>


                                    <template #popper>
                                        <div class="p-2 d-flex gap-2 flex-column">

                                            <OptionActionDataTable @click="acessarCobranca(row)" text="Acessar cobrança"
                                                icon="ri-eye-line">
                                            </OptionActionDataTable>

                                            <OptionActionDataTable v-if="authStore.usuario.root && row.status == 'PENDENTE'"
                                                @click="confirmarCobrancaDinheiro(row)"
                                                text="Confirmar recebimento em dinheiro"
                                                icon="ri-money-dollar-circle-line">
                                            </OptionActionDataTable>

                                        </div>
                                    </template>
                                </DropdownFloating>
                            </span>

                        </template>

                        <!-- Colunas de status -->
                        <template v-else-if="column.field == 'status'">

                            <BadgeField v-if="row.status == 'PAGO'" type="success" text="Pago" :rounded="true">
                            </BadgeField>

                            <BadgeField v-else-if="row.status == 'PENDENTE'" type="danger" text="Aguardando Pagamento"
                                :rounded="true">
                            </BadgeField>

                            <BadgeField v-else-if="row.status == 'CANCELADO'" type="danger" text="Cancelado"
                                :rounded="true">
                            </BadgeField>

                        </template>

                        <!-- Colunas de formas de pagamento -->
                        <template v-else-if="column.field == 'formaPagamento'">

                            <BadgeField v-if="row.formaPagamento == 'NAO_DEFINIDO'" type="info" text="Não Definido"
                                :rounded="true">
                            </BadgeField>

                            <BadgeField v-if="row.formaPagamento == 'BOLETO'" type="info" text="Boleto" :rounded="true">
                            </BadgeField>

                            <BadgeField v-if="row.formaPagamento == 'CARTAO_CREDITO'" type="info"
                                text="Cartão de Crédito" :rounded="true">
                            </BadgeField>

                            <BadgeField v-if="row.formaPagamento == 'PIX'" type="info" text="PIX" :rounded="true">
                            </BadgeField>

                            <BadgeField v-if="row.formaPagamento == 'DINHEIRO'" type="success"
                                text="Recebido em Dinheiro" :rounded="true">
                            </BadgeField>

                        </template>

                        <!-- Colunas de data de vencimento -->
                        <template v-else-if="column.field == 'dataVencimento'">
                            {{ $dataUtils.formatDate(row.dataVencimento) }}
                        </template>

                        <!-- Colunas de data de vencimento -->
                        <template v-else-if="column.field == 'dataPagamento'">
                            {{ $dataUtils.formatDate(row.dataPagamento) }}
                        </template>

                        <!-- Colunas de valor -->
                        <template v-else-if="column.field == 'valor'">
                            {{ $moneyConvert.convert(row.valor) }}
                        </template>

                        <template v-else-if="column.field == 'progresso_install'">
                            <ProgressBar :value="row.progresso_install" max="100"></ProgressBar>
                        </template>

                        <!-- Colunas normais -->
                        <template v-else>
                            {{ row[column.field] }}
                        </template>
                    </template>

                </BaseTable>

            </div>



        </div>
    </div>

</template>

<script>

import { useAuthStore } from '@/stores/auth.js';
import api from '@/services/api'
import { toast } from 'vue3-toastify'

import SocketService from '@/services/SocketService';

export default {
    props: {
        isVisible: {
            type: Boolean,
            default: false
        },
        aplicacao: {
            type: Object
        }
    },
    emits: ['close'],
    data() {
        return {

            authStore: useAuthStore(),
            dataTableHead:
                [
                    { label: 'Id', field: 'payment', tdClass: 'td-vertical-middle' },
                    { label: 'Valor', field: 'valor', tdClass: 'td-vertical-middle' },
                    { label: 'Data de Vencimento', field: 'dataVencimento', tdClass: 'td-vertical-middle' },
                    { label: 'Status', field: 'status', tdClass: 'td-vertical-middle' },
                    { label: 'Data de Pagamento', field: 'dataPagamento', tdClass: 'td-vertical-middle' },
                    { label: 'Forma de Pagamento', field: 'formaPagamento', tdClass: 'td-vertical-middle' },
                    { label: 'Ações', field: '__actions', sortable: false, tdClass: 'td-actions td-vertical-middle text-center' }
                ],
            cobrancas: []



        }
    },
    watch: {
        'aplicacao': {
            handler() {
                if (this.aplicacao.id) this.getCobrancas()
            },
            immediate: true
        }
    },
    methods: {
        acessarCobranca(cobranca) {
            cobranca.dropdownShown = false
            window.open(cobranca.invoiceURL, '_blank')
        },
        async confirmarCobrancaDinheiro(cobranca) {
            cobranca.dropdownShown = false

            this.$swal({
                title: 'Tem certeza?',
                text: `Você realmente deseja confirmar o pagamento dessa cobrança em dinheiro?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Cancelar',
            }).then(async (result) => {
                if (result.isConfirmed) {

                    this.$notiflix.Loading.standard('Atualizando Cobrança')
                    const response = await api.post(`/asaas/receiveInCash`, { id: cobranca.id }, {
                        headers: {
                            Authorization: `Bearer ${this.authStore.access_token}`
                        }
                    })
                    this.$notiflix.Loading.remove()

                    console.log(response.status)

                    if(response.status == 200 || response.status == 201){
                        toast.success("Cobrança atualizada")
                    }else{
                        toast.error("Não foi possível atualizar essa cobrança")
                    }

                }
            })

            

        },
        closeModal() {
            this.$emit('close');
        },
        async getCobrancas() {

            this.$notiflix.Loading.standard('Buscando Cobranças')
            const result = await api.get(`/aplicacao-cobranca/aplicacao/${this.aplicacao.id}`, {
                headers: {
                    Authorization: `Bearer ${this.authStore.access_token}`
                }
            })
            this.cobrancas = result.data
            this.$notiflix.Loading.remove()

        }
    },
    mounted() {

        SocketService.connect()

        SocketService.on('update_cobranca', (res) => {

            console.log('Update cobrança')
            console.log(res)
            const index = this.cobrancas.findIndex(cobranca => cobranca.id == res.cobranca.id)
            if (index != -1) this.cobrancas[index] = res.cobranca

        })

    },
    beforeUnmount() {
        SocketService.disconnect()
    }
}
</script>